import { GeneralInformationData } from '@/common/types/generalInformation.type'
import { MaintenanceForwardingEstablishmentChoiceEntryAuctionEntryData } from './auctionEntry/auctionEntry.type'
import { MaintenanceForwardingEstablishmentChoiceEntryProposalContentData } from './proposalContents/proposalContent.type'

export enum MaintenanceForwardingEstablishmentChoiceEntryKlass {
  ManualEntry = 'Maintenance::EstablishmentChoice::ManualEntry',
  AuctionEntry = 'Maintenance::EstablishmentChoice::AuctionEntry',
}

export enum MaintenanceForwardingEstablishmentChoiceEntryProposalStatus {
  Canceled = 'canceled',
  Completed = 'completed',
  AwaitingEstablishmentResponse = 'awaiting_establishment_response',
  AwaitingClientResponse = 'awaiting_client_response',
}

export type MaintenanceForwardingEstablishmentChoiceEntryProposalData = {
  id: string
  proposal_content: MaintenanceForwardingEstablishmentChoiceEntryProposalContentData
  status: MaintenanceForwardingEstablishmentChoiceEntryProposalStatus
  process_started_at: string | null
  canceled_at: string | null
  establishment_accepted_at: string | null
  establishment_rejected_at: string | null
  client_accepted_at: string | null
  client_rejected_at: string | null
  establishment: {
    id: string
    general_information: Pick<GeneralInformationData, 'fantasy_name' | 'company_logo'>
  }
  establishment_accepted_by: {
    id: string
    full_name: string
  } | null
  establishment_rejected_by: string | null
  client_accepted_by: string | null
  client_rejected_by: string | null
}

export type MaintenanceForwardingEstablishmentChoiceEntryData = {
  id: string
  actual_proposal: MaintenanceForwardingEstablishmentChoiceEntryProposalData
  canceled_at: string | null
  completed_at: string | null
  establishment: {
    id: string
    general_information: Pick<GeneralInformationData, 'fantasy_name' | 'company_logo'>
  }
  process_started_at: string
  status: string
}

export type MaintenanceForwardingEstablishmentChoiceEntryMap = {
  [MaintenanceForwardingEstablishmentChoiceEntryKlass.ManualEntry]: MaintenanceForwardingEstablishmentChoiceEntryData
  [MaintenanceForwardingEstablishmentChoiceEntryKlass.AuctionEntry]: MaintenanceForwardingEstablishmentChoiceEntryAuctionEntryData
}
